var api = {
  Login: '/auth/login',
  Logout: '/api/auth/logout',
  ForgePassword: '/api/auth/forge-password',
  Register: '/api/auth/register',
  SendSms: '/api/account/sms',
  // get my info
  UserInfo: '/api/user/info'
};
export default api;